export default __webpack_public_path__ + "static/media/inbox.61d91d48.svg";